import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  fill: "currentColor",
  stroke: "currentColor",
  class: "bi bi-door-out"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.86.917a.33.33 0 0 0-.266.327v21.988a.33.33 0 0 0 .204.306l13.06 5.438a.326.326 0 0 0 .449-.306v-5.224h3.265a.326.326 0 0 0 .326-.327V1.244a.326.326 0 0 0-.326-.327H2.86zm1.58.653h14.805v21.223h-2.938V7.121a.33.33 0 0 0-.194-.296Zm-1.193.174 12.407 5.581V28.18L3.247 23.017Zm20.518 7.01a.327.327 0 0 0-.163.57l2.622 2.368h-4.04a.3.3 0 0 0-.154.03.326.326 0 0 0 .154.623h4.04l-2.622 2.367a.325.325 0 0 0-.052.478.326.326 0 0 0 .48.012l3.266-2.939a.327.327 0 0 0 0-.49L24.03 8.835a.33.33 0 0 0-.266-.082zm-12.743 5.223a.327.327 0 0 0-.072.623l2.092.898v1.418a.327.327 0 1 0 .653 0v-1.633a.33.33 0 0 0-.194-.295l-2.285-.98a.33.33 0 0 0-.194-.03z" }, null, -1)
  ])))
}
export default { render: render }